<template>
  <div class="active-basic">
    <div class="common-form">基本信息</div>

    <el-form-item label="名称" prop="name" :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]">
      <el-input v-model="form.name" placeholder="请输入名称" class="max-w460"></el-input>
    </el-form-item>

    
    <el-form-item label="备注" prop="name" >
      <el-input v-model="form.remark" placeholder="请输入备注" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>



    <el-form-item label="类型">
        <el-radio-group v-model="form.code" :disabled="form.ind<=0?false:true">
          <el-radio label="ad">广告</el-radio>
          <!-- <el-radio label="keyword">关键字</el-radio> -->
          <!-- <el-radio label="store">企业排名</el-radio> -->
          <!-- <el-radio label="coc">诚优企业</el-radio> -->
        </el-radio-group>

      </el-form-item>

      <!-- 购买关键字 -->
      <div v-if="form.code == 'keyword'">
        <el-form-item label="关键字"   prop="keyword" 
        :rules="[{ required: true, message: '请输入关键字', trigger: 'blur' }]">
          <el-input :disabled="form.ind<=0?false:true" v-model="form.keyword" placeholder="请输入关键字" class="max-w460"></el-input>
        </el-form-item>



        <el-form-item label="关键字位置" prop="setting" >
        <div>
             <el-button icon="el-icon-plus" @click.stop="add">添加关键字位置</el-button>
           </div>

           <table v-if="form.setting" border cellspacing="0" class="mt10" style="border:1px solid #b8b8b8">
             <tr  style="border:1px solid #b8b8b8">
               <th class="w150" style="width: 100px">位置</th>
               <th class="w150" style="width: 150px">价格（元/天）</th>
               <th class="w150" style="width: 80px">是否售出</th>
               <th class="w150" style="width: 150px">是否开启</th>
               <th class="w150" style="width: 100px">操作</th>
             </tr>
             <tr v-for="(item,index) in form.setting" style="border:1px solid #b8b8b8">
               <td class="tc">{{ item.index }} </td>
               <td class="tc">
                  <el-input v-model="item.price" placeholder="请输入价格（按天）"></el-input>
               </td>
               <td class="tc">
                <span v-if="item.is_sell == 0">未售出</span>
                <span v-if="item.is_sell == 1">已售出</span>
              </td>
              <td class="tc">
                <el-switch v-model="item.status" active-text="启用" inactive-text="关闭" 
                active-value="1" inactive-value="0"></el-switch>

              </td>
               <td class="tc" style="width: 100px;">
                <a @click="del(item.id,index)" v-if="item.is_sell==0"> 删除</a>
              </td>
             </tr>
           </table>

           <div>剩余的商品根据搜索自身排序</div>
    </el-form-item>

      </div>

      <!-- 购买诚优企业 -->
      <div v-if="form.code == 'coc'">
    

    <el-form-item label="诚优企业" prop="setting" >
    <div>
         <el-button icon="el-icon-plus" @click.stop="add('coc')">添加广告位</el-button>
       </div>

       <table v-if="form.setting" border cellspacing="0" class="mt10" style="border:1px solid #b8b8b8">
         <tr  style="border:1px solid #b8b8b8">
           <th class="w150" style="width: 150px">位置</th>
           <th class="w150" style="width: 150px">价格（元/天）</th>
           <th class="w150" style="width: 80px">是否售出</th>
           <th class="w150" style="width: 150px">是否开启</th>
           <th class="w150" style="width: 100px">操作</th>
         </tr>
         <tr v-for="(item,index) in form.setting" style="border:1px solid #b8b8b8">
           <td class="tc">{{ item.index }} </td>
           <td class="tc">
              <el-input v-model="item.price" placeholder="请输入价格（按天）"></el-input>
           </td>
           <td class="tc">
            <span v-if="item.is_sell == 0">未售出</span>
            <span v-if="item.is_sell == 1">已售出</span>
          </td>
          <td class="tc">
            <el-switch v-model="item.status" active-text="启用" inactive-text="关闭" 
            active-value="1" inactive-value="0"></el-switch>

          </td>
           <td class="tc" style="width: 100px;">
            <a @click="del(item.id,index)" v-if="item.is_sell==0"> 删除</a>
          </td>
         </tr>
       </table>

       <div>诚优企业比较特殊，广告只需发布一个，位置只需发布一个，发布多个无效，且不能后台购买，需要商会会员在前端申请购买</div>
</el-form-item>

  </div>
      <!-- 购买商品排名 -->
     <div v-if="form.code == 'store'">
    

        <el-form-item label="商品排名位置" prop="setting" >
        <div>
             <el-button icon="el-icon-plus" @click.stop="add">添加商品排名位置</el-button>
           </div>

           <table v-if="form.setting" border cellspacing="0" class="mt10" style="border:1px solid #b8b8b8">
             <tr  style="border:1px solid #b8b8b8">
               <th class="w150" style="width: 100px">位置</th>
               <th class="w150" style="width: 150px">价格（元/天）</th>
               <th class="w150" style="width: 80px">是否售出</th>
               <th class="w150" style="width: 150px">是否开启</th>
               <th class="w150" style="width: 100px">操作</th>
             </tr>
             <tr v-for="(item,index) in form.setting" style="border:1px solid #b8b8b8">
               <td class="tc">{{ item.index }} </td>
               <td class="tc">
                  <el-input v-model="item.price" placeholder="请输入价格（按天）"></el-input>
               </td>
               <td class="tc">
                <span v-if="item.is_sell == 0">未售出</span>
                <span v-if="item.is_sell == 1">已售出</span>
              </td>
              <td class="tc">
                <el-switch v-model="item.status" active-text="启用" inactive-text="关闭" 
                active-value="1" inactive-value="0"></el-switch>

              </td>
               <td class="tc" style="width: 100px;">
                <a @click="del(item.id,index)" v-if="item.is_sell==0"> 删除</a>
              </td>
             </tr>
           </table>

           <div>该设置只针对DIY装修的商品组，剩余商品按原来排序进行</div>
    </el-form-item>

      </div>



    <div v-if="form.code == 'ad'">
      <el-form-item label="类型">
        <el-radio-group v-model="form.type" :disabled="form.ind<=0?false:true">
          <el-radio label="1">bannar图</el-radio>
          <el-radio label="2">单图</el-radio>
        </el-radio-group>

        <div>选择单图，广告只会显示第一张;当有广告售出时，不再支持修改</div>
      </el-form-item>

      <el-form-item label="广告位置" prop="location_id" :rules="[{ required: true, message: '请选择广告位置', trigger: 'blur' }]">
      <el-select v-model="form.location_id" placeholder="请选择"  :disabled="form.ind<=0?false:true">
        <el-option v-for="item in positionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <div>当有广告售出时，不再支持修改</div>
    </el-form-item>


      <el-form-item label="是否显示广告标识">
        <el-radio-group v-model="form.is_label">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>


      <el-form-item label="广告" prop="setting" >
        <div>
             <el-button icon="el-icon-plus" @click.stop="add">添加广告</el-button>
           </div>

           <table v-if="form.setting" border cellspacing="0" class="mt10" style="border:1px solid #b8b8b8">
             <tr  style="border:1px solid #b8b8b8">
               <th class="w150" style="width: 100px">位置</th>
               <th class="w150" style="width: 80px">图片</th>
               <th class="w150" style="width: 150px">价格（元/天）</th>
               <th class="w150" style="width: 80px">图片高度</th>
               <th class="w150" style="width: 80px">是否售出</th>
               <th class="w150" style="width: 150px">是否开启</th>
               <th class="w150" style="width: 100px">操作</th>
             </tr>
             <tr v-for="(item,index) in form.setting" style="border:1px solid #b8b8b8">
               <td class="tc">{{ item.index }} </td>
               <td class="tc"> 
                <div class="d-c-c ad-picture" @click="openUpload(index)" >
                    <img v-if="item.image_url" :src="item.image_url" width="200" height="124" />
                    <span v-else class="el-icon-picture-outline"></span>
                  </div>
                  <p class="ml10 gray">提示：图片尺寸建议750x310</p>

               </td>
               <td class="tc">
                  <el-input v-model="item.price" placeholder="请输入价格（按天）"></el-input>
               </td>
               <td class="tc">
                  <el-input v-model="item.height" placeholder="请输入图片高度，单位rpx"></el-input>
               </td>
               <td class="tc">
                <span v-if="item.is_sell == 0">未售出</span>
                <span v-if="item.is_sell == 1">已售出</span>
              </td>
              <td class="tc">
                <el-switch v-model="item.status" active-text="启用" inactive-text="关闭" 
                active-value="1" inactive-value="0"></el-switch>

              </td>
               <td class="tc" style="width: 100px;">
                <a @click="del(item.id,index)" v-if="item.is_sell==0"> 删除</a>
              </td>
             </tr>
           </table>
     
    </el-form-item>

    </div>
   

    
   
      <el-form-item label="排序">
        <el-input type="number" v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>

    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import Upload from '@/components/file/Upload';

export default {
  components: {
    Upload,
  },
  data() {
    
    /*验证图片是否上传*/
    const validatorImages = (rule, value, callback) =>{
    	if(value<1){
    		return callback(new Error('请上传活动图'));
    	}else{
         callback();
    	}
    };

    return {
       /*是否打开添加弹窗*/
        open_add: false,
      /*是否上传图片*/
      isupload: false,
      index:0,
      /*图片是否上传了*/
      rulesImage: [{ validator: validatorImages, required: true, message: '请上传图片', trigger: 'change' }]
    };
  },
  props: {
    form: Object,
    positionList:Array
  },
  methods: {
     /*上传*/
     openUpload(e) {
      this.index = e;
      console.log(" this.index", this.index)
      this.isupload = true;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        console.log(e[0].file_path)
        this.form.setting[this.index].image_id = e[0].file_id;
        this.form.setting[this.index].image_url = e[0].file_path;
      }
      this.isupload = false;
    },
    add(code=""){
      if(this.form.status == 2 && this.form.setting.length>=1){
        this.$message({
                message: '单图只能上传一个广告哦',
                type: 'info'
              });
        return;
      }
      if(code == "coc"){
        if(this.form.setting.length >= 1){
          this.$message({
                message: '诚优企业只能发布一个位置',
                type: 'info'
              });
          return;
        }
      }
      this.form.setting.push({
        index:  this.form.setting.length+1,
        is_sell:0 ,
        status:"1",
        price:99,
        image_url:"",
        image_id:0,
        height:300
      });
      console.log('this.form.setting',this.form.setting);
    },
    del(e,index){//删除广告
      this.form.setting.splice(index, 1);
    },
    /*打开弹出层*/
      addClick() {
        this.open_add = true;
      },
    
  }
};
</script>

<style lang="scss" scoped="scoped">
.active-basic .ad-picture {
  width: 200px;
  height: 84px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
.active-basic .ad-picture:hover {
  border: 1px dashed $blue;
}

.active-basic .ad-picture img {
  object-fit: fill;

}
 .img {
    margin-top: 10px;
  }

  .w150{
    border: 1px solid #eee;
  }
  .tc{
    border: 1px solid #eee;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/ad/ad/part/Basic.vue